import { useGetIdentity, useTranslate } from "ra-core";

import { BrandKit } from "../client-files/BrandKit";
import { ClientReports } from "../client-files/ClientReports";

// Client portal pages: read-only views scoped to the client's company (RLS).

export const PortalReportsPage = () => {
  const translate = useTranslate();
  const { identity } = useGetIdentity();
  if (identity?.companyId == null) return null;
  return (
    <div className="mt-6 flex flex-col gap-6 pb-8">
      <h1 className="text-3xl font-semibold tracking-tight">
        {translate("resources.client_reports.title")}
      </h1>
      <section className="rounded-[22px] bg-card p-5">
        <ClientReports companyId={identity.companyId} />
      </section>
    </div>
  );
};

PortalReportsPage.path = "/reports";

export const PortalBrandPage = () => {
  const translate = useTranslate();
  const { identity } = useGetIdentity();
  if (identity?.companyId == null) return null;
  return (
    <div className="mt-6 flex flex-col gap-6 pb-8">
      <h1 className="text-3xl font-semibold tracking-tight">
        {translate("resources.brand_assets.menu")}
      </h1>
      <section className="rounded-[22px] bg-card p-5">
        <BrandKit companyId={identity.companyId} canManage={false} />
      </section>
    </div>
  );
};

PortalBrandPage.path = "/brand";
